<template>
  <div class="pa-2">
    <!-- textserach -->
    <div style="display: flex; width: 100%; align-items: center">
      <v-text-field
        v-model="urlbt"
        :clearable="!edit ?? false"
        :loading="loading && urlbt?.length > 3"
        :readonly="edit ?? false"
        :placeholder="placeholder"
        :rules="[dtUrlRule]"
        class="identifier-input"
        clear-icon="mdi-close-circle-outline"
        direction="ltr"
        style="direction: ltr; width: 80%"
        :style="{ color: isValid ? 'green' : '' }"
        @keydown.enter="checkUrl"
        outlined
        dense
      >
        <template v-slot:prepend-inner>
          <v-card
            class="d-flex align-center px-2"
            color="grey lighten-2"
            flat
            height="40"
            width="fit-content"
          >
            <span class="pl-2">{{ domainPrefix }}</span>
          </v-card>
        </template>
      </v-text-field>
    </div>

    <!-- cart -->
    <v-card v-if="isValid" elevation="0">
      <v-card-title> تنظیمات </v-card-title>

      <v-col class="d-flex" cols="12" style="padding: 0; gap: 10px">
        <v-text-field
          v-if="newTypeShow"
          v-model="newType"
          clear-icon="mdi-close-circle-outline"
          type="text"
          clearable
          dense
          hint="لطفا نوع کاربری جدید خود را وارد کنید"
          label="نوع کاربری"
          counter="15"
          maxLength="70%"
          outlined
          @keydown.enter="addNewType"
          prepend-icon="mdi-close"
          @click:prepend="newTypeShow = false"
        >
          <template v-slot:append>
            <div
              @click="addNewType"
              class="d-flex align-center"
              style="cursor: pointer; gap: 5px"
            >
              <v-icon size="20" color="primary">mdi-plus-box</v-icon>
              افزودن
            </div>
          </template>
        </v-text-field>
        <v-combobox
          v-else
          :items="pay.use_type_items"
          v-model="pay.use_type"
          label="نوع کاربری"
          append-icon="mdi-chevron-down"
          dense
          outlined
          hide-no-data
          hide-selected
          menu-props="offsetY"
        >
          <template v-slot:append-item>
            <v-btn
              v-if="!newTypeShow"
              @click="newTypeShow = true"
              outlined
              color="green"
              width="100%"
              class="pa-2"
            >
              <v-icon size="20">mdi-plus</v-icon>
              افزودن کاربری جدید
            </v-btn>
          </template>
        </v-combobox>
      </v-col>
      <v-col v-if="pay.use_type" cols="12" style="padding: 0">
        <v-combobox
          :items="type"
          item-text="text"
          item-value="value"
          v-model="pay.type"
          :label="`نوع ${pay.use_type}`"
          append-icon="mdi-chevron-down"
          dense
          outlined
        ></v-combobox>
      </v-col>
      <v-col cols="12" style="padding: 0">
        <v-text-field
          v-model="use_type_dynmic"
          append-icon="mdi-button-pointer"
          clear-icon="mdi-close-circle-outline"
          type="text"
          clearable
          dense
          hint="لطفا نوشته دکمه زیر نمایش فروشگاه را وارد کنید"
          label="متن دکمه"
          counter="25"
          maxLength="70%"
          outlined
        />
      </v-col>
      <v-card-title>تعیین اجاره</v-card-title>
      <v-row>
        <v-col cols="12" sm="6">
          <!-- <v-text-field
            v-model="pay.rent.rent"
            @input="formatNumber"
            append-icon="mdi-account-cash"
            clear-icon="mdi-close-circle-outline"
            type="number"
            clearable
            dense
            hint="لطفا مبلغ اجاره را وارد کنید."
            label="مبلغ اجاره"
            maxLength="70%"
            outlined
          /> -->
          <price-input
            dense
            clearable
            label="مبلغ اجاره"
            v-model="pay.rent.rent"
            type="number"
            text-center="true"
          ></price-input>
        </v-col>
        <v-col>
          <v-text-field
            v-model="pay.rent.rend_due_days"
            append-icon="mdi-clipboard-text-clock"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'مقدار باید بین ۱ تا ۳۰ باشد',
            ]"
            type="number"
            clearable
            dense
            hint="لطفا روز پرداخت اجاره را وارد کنید."
            label="روز پرداخت اجاره"
            maxLength="70%"
            outlined
          />
        </v-col>
      </v-row>

      <v-switch v-model="fine" label="جریمه دیرکرد اجاره"> </v-switch>

      <v-card-subtitle v-if="fine">تعیین جریمه دیرکرد اجاره</v-card-subtitle>
      <v-row v-if="fine">
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="pay.rent.late_rent_percentage"
            append-icon="mdi-percent"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'درصد جریمه باید بین 1 تا 30 درصدباشد',
            ]"
            type="number"
            clearable
            dense
            hint="درصد جریمه دیرکرد پرداخت اجاره ماهیانه"
            label="درصد جریمه اجاره"
            maxLength="70%"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="pay.rent.late_rend_days"
            append-icon="mdi-clipboard-text-clock"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'تعداد روزهای وارد شده نباید بیشتر 30 و کمتر از 1 باشد',
            ]"
            type="number"
            clearable
            dense
            hint="مهلت زمان پرداخت اجاره"
            label="مهلت پرداخت"
            maxLength="70%"
            outlined
          />
        </v-col>
      </v-row>
      <v-card-title>تعیین شارژ</v-card-title>

      <v-row class="" style="n">
        <v-col cols="12" sm="6">
          <price-input
            v-model="pay.charge.charge"
            text-center="true"
            clearable
            dense
            label="مبلغ شارژ"
            type="number"
          ></price-input>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="pay.charge.charge_due_days"
            append-icon="mdi-clipboard-text-clock"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'مقدار باید بین ۱ تا ۳۰ باشد',
            ]"
            type="number"
            clearable
            dense
            hint="لطفا روز پرداخت را وارد کنید."
            label="روز پرداخت شارژ "
            maxLength="70%"
            outlined
          />
        </v-col>
      </v-row>
      <v-switch v-model="fine2" label="جریمه دیرکرد شارژ"> </v-switch>

      <v-card-subtitle v-if="fine2">تعیین جریمه دیرکرد شارژ</v-card-subtitle>
      <v-row v-if="fine2">
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="pay.charge.late_charge_percentage"
            append-icon="mdi-percent"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'درصد جریمه باید بین 1 تا 30 درصدباشد',
            ]"
            type="number"
            clearable
            dense
            hint="درصد جریمه دیرکرد پرداخت شارژ ماهیانه"
            label="درصد جریمه شارژ"
            maxLength="70%"
            outlined
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="pay.charge.late_charge_days"
            append-icon="mdi-clipboard-text-clock"
            clear-icon="mdi-close-circle-outline"
            :rules="[
              (v) =>
                v === null ||
                v === '' ||
                (v <= 30 && v >= 1) ||
                'تعداد روزهای وارد شده نباید بیشتر 30 و کمتر از 1 باشد',
            ]"
            type="number"
            clearable
            dense
            hint="مهلت زمان پرداخت شارژ"
            label="مهلت پرداخت"
            maxLength="70%"
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mr-3">
          <v-switch v-model="pattern" label="پیگیری پرداخت"> </v-switch>
        </v-col>
        <template v-if="pattern">
          <v-col class="pt-2" cols="12">
            <sms-pattern-picker
              v-model="selectedRow"
              @reload="(e) => (rerender = e)"
            />
          </v-col>

          <v-col
            v-if="!!selectedRow && !!Object.keys(selectedRow).length"
            cols="12"
          >
            <pattern-inputs-generate
              v-model="computedMessage"
              :is-campaign="selectedRow.hasOwnProperty('campId')"
              :message="selectedRow"
            />
          </v-col>
        </template>
      </v-row>
    </v-card>
    <!-- button -->
    <div
      dir="rtl"
      style="width: 100%; display: flex; justify-content: flex-end"
    >
      <div class="w-100" v-if="edit">
        <v-btn
          width="100%"
          :color="'green'"
          outlined
          class="my-3"
          @click="
            $emit('click', {
              pay: pay,
              qr_id: editShopValue?.qr_id,
              punish: { fine, fine2 },
            });
            isValid = true;
            loading = false;
            clearPay();
          "
        >
          <v-icon size="20" class="mr-1">mdi-content-save-edit</v-icon>
          ثبت ویرایش
        </v-btn>
      </div>
      <div class="w-100" v-else>
        <v-btn
          v-if="isValid"
          width="100%"
          :color="'green'"
          outlined
          class="my-3"
          @click="
            $emit('click', { pay: pay, data: data });
            isValid = false;
            loading = false;
            clearPay();
          "
        >
          <v-icon size="20" class="mr-1">mdi-content-save-check</v-icon>
          ثبت
        </v-btn>
        <v-btn
          v-else
          width="100%"
          color="orange"
          :loading="loading && urlbt?.length > 3"
          :disabled="loading"
          outlined
          class="my-3"
          @click="checkUrl"
        >
          <v-icon size="20" class="ml-2">mdi-magnify </v-icon>
          جستجو
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import customDatePicker from "../../content/custom-date-picker.vue";
import priceInput from "@/view/pages/uiBeautifier/priceInput";

export default {
  name: "qrAddressField",
  components: { customDatePicker, priceInput },

  props: {
    value: [String, null],
    editShopValue: [Object, null],
    edit: [Boolean, null],
  },

  data() {
    return {
      valueModel: this?.value,
      placeholder: "terminalads",
      dtUrlRule: (v) =>
        (v &&
          v.length >= 3 &&
          /^[^\u0600-\u06FF]+$/.test(v) &&
          this.isURL(v)) ||
        "حداقل کاراکتر : 3 عدد، بدون حروف فارسی و غیرمجاز",
      domainPrefix: "qrland.in/",
      loading: false,
      isValid: false,
      showEditDialog: false,
      isRequestPending: false, // برای جلوگیری از درخواست‌های همزمان
      type_items: [
        "فروشگاه",
        "شهربازی",
        "غرفه",
        "کافی شاپ",
        "رستوران",
        "فست فودی",
        "اداری",
      ],
      type: [
        { text: "فیزیکی", value: "physical" },
        { text: "آنلاین", value: "online" },
      ],
      // در صورت اضافه شدن فیلد جدید در متد clearPay اضافه شود
      pay: {
        rent: {
          rent: 0,
          rend_due_days: 0,
          late_rent_percentage: 0,
          late_rend_days: 0,
        },
        charge: {
          charge: 0,
          charge_due_days: 0,
          late_charge_percentage: 0,
          late_charge_days: 0,
        },
        button: {
          title: "",
        },
        use_type_items: [
          "فروشگاه",
          "شهربازی",
          "غرفه",
          "کافی شاپ",
          "رستوران",
          "فست فودی",
          "اداری",
        ],
        use_type: "فروشگاه",
        type: { text: "فیزیکی", value: "physical" },
      },
      fine: false,
      fine2: false,
      pattern: false,
      data: {},
      errors: [],
      selectedRow: {},
      newType: "",
      newTypeShow: false,
      rent: "",
      charge: "",
    };
  },

  computed: {
    isReadOnly() {
      return this.$attrs.hasOwnProperty("readonly");
    },
    urlbt: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    use_type_dynmic: {
      get() {
        return `مشاهده اطلاعات ${this.pay.use_type}`;
      },
      set(val) {
        this.pay.button.title = val;
      },
    },
  },

  watch: {
    urlbt(val, oldVal) {
      if (val !== oldVal && !this.edit) {
        this.isValid = false;
        this.clearPay();
        this.loading = false;
        this.fine = false;
      }
    },
    use_type_dynmic(val) {
      this.pay.button.title = val;
    },
    editShopValue: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && this.edit) {
          this.pay = {
            rent: {
              rent: val.rent ?? 0,
              rend_due_days: val.rend_due_days ?? 0,
              late_rend_days: val.late_rend_days ?? 0,
              late_rent_percentage: val.late_rent_percentage ?? 0,
            },
            charge: {
              charge: val.charge ?? 0,
              charge_due_days: val.charge_due_days ?? 0,
              late_charge_percentage: val.late_charge_percentage ?? 0,
              late_charge_days: val.late_charge_days ?? 0,
            },
            use_type: val.use_type || "فروشگاه",

            type:
              val.type === "physical"
                ? { text: "فیزیکی", value: "physical" }
                : { text: "آنلاین", value: "online" },
            button: { title: val.alias },
            use_type_items: val.use_type_items || [
              "فروشگاه",
              "شهربازی",
              "غرفه",
              "کافی شاپ",
              "رستوران",
              "فست فودی",
              "اداری",
            ],
          };
          this.isValid = true;
          this.fine = val.late_rent_percentage ? true : false;
          this.fine2 = val.late_charge_percentage ? true : false;
        }
      },
    },
  },

  methods: {
    isURL(str) {
      let regex = /^[a-zA-Z0-9\-_~:?#[\]@!$&'()+,;=.]+$/;
      return regex.test(str);
    },

    clearPay() {
      this.pay = {
        rent: {
          rent: 0,
          rend_due_days: 0,
          late_rent_percentage: 0,
          late_rend_days: 0,
        },
        charge: {
          charge: 0,
          charge_due_days: 0,
          late_charge_percentage: 0,
          late_charge_days: 0,
        },
        use_type_items: [
          "فروشگاه",
          "شهربازی",
          "غرفه",
          "کافی شاپ",
          "رستوران",
          "فست فودی",
          "اداری",
        ],
        button: {
          title: "مشاهده اطلاعات فروشگاه",
        },

        use_type: "فروشگاه",
        type: { text: "فیزیکی", value: "physical" },
      };

      this.data = {};
    },

    async checkUrl() {
      if (
        this.isRequestPending ||
        this.urlbt.length < 3 ||
        !this.isURL(this.urlbt)
      ) {
        this.isValid = false;
        return;
      }

      this.isRequestPending = true;
      this.loading = true;
      this.isValid = false;
      this.data = {};

      try {
        const response = await this.$api.post(
          `${this.$qrApi}/v1/commercial/find`,
          { domain: "qrland.in", identifier: this.urlbt },
        );
        if (response.data && response.data.data) {
          this.data = response.data.data;
          this.isValid = response.status === 200;
          this.$toast.success("آدرس کیوآر لند شما با موفقیت یافت شد");
        } else {
          throw new Error("پاسخ API نامعتبر است");
        }
      } catch (error) {
        this.isValid = false;
        this.$toast.error("آدرس کیوآری یافت نشد");
      } finally {
        this.loading = false;
        this.isRequestPending = false;
      }
    },
    addNewType() {
      if (this.newType.length > 3) {
        this.pay.use_type_items.push(this.newType);
        this.pay.use_type = this.newType;
        this.newType = "";
        this.newTypeShow = false;
        this.$toast.success("نوع کاربری جدید شما اضافه شد");
      } else {
        tis.$toast.error("نوع کاربری شما نمیتواند کمتر از 4 کارکتر داشته باشد");
      }
    },
    formatNumber(value) {
      if (value) {
        // حذف کاماها برای پردازش
        const cleanedValue = value.replace(/,/g, "");
        // ذخیره مقدار خام
        this.pay.rent.rent = cleanedValue;
        // فرمت برای نمایش
        this.$nextTick(() => {
          this.pay.rent.rent = cleanedValue.toLocaleString();
        });
      } else {
        this.pay.rent.rent = 0;
      }
    },
  },
  mounted() {
    if (this.edit) {
      this.isValid = true;
    }
  },
};
</script>

<style scoped>
.v-input.identifier-input >>> .v-input__slot {
  padding-left: 0 !important;
}

.v-input >>> .v-input__prepend-inner {
  margin: 0 !important;
  padding-left: 0;
  padding-right: 4px;
}

.identifier-input .v-card {
  font-size: 14px;
  padding-left: 8px;
  display: flex;
  align-items: center;
}

.identifier-input .v-text-field__input {
  padding-left: 0 !important;
  border-radius: 16px; /* گوشه‌های گرد */
}
</style>
